export const ApiHttpPaths = {
    GET: {
        agencies: {
            agencies: () => ({
                protected: true,
                url: '/v1/agencies',
            }),
        },
        customers: {
            customer: (id) => ({
                protected: true,
                url: `/v1/admin/customers/${id}`,
            }),
            matchedGrants: (id) => ({
                protected: true,
                url: `/v1/admin/customers/${id}/matchedGrants`,
            }),
            matchedPF: (id) => ({
                protected: true,
                url: `/v1/admin/customers/${id}/matchedPFs`,
            }),
        },
        subscription: {
            checkoutSession: () => ({
                protected: true,
                url: '/v1/subscription/stripe/session',
            }),
        },
    },
    POST: {
        auth: {
            register: () => ({
                protected: false,
                url: '/v1/auth/register',
            }),
            session: () => ({
                protected: false,
                url: '/v1/session',
            }),
        },
        customers: {
            create: () => ({
                protected: true,
                url: '/v1/admin/customers',
            }),
        },
        subscription: {
            kickstartSession: (customerId) => ({
                protected: true,
                url: `/v1/subscription/stripe/session/${customerId}/kickstart`,
            }),
        },
        communications: {
            campaigns: {
                kickstartFollowup: () => ({
                    protected: true,
                    url: '/v1/communications/transactions/email/matchedGrants',
                }),
            },
        },
    },
    DELETE: {
        auth: {
            session: () => ({
                protected: true,
                url: '/v1/session',
            }),
        },
    },
};
